
import angular from 'angular';


const controllerInfo = {
    module: 'ib-seat-map-module',
    inject: [],
    required: []
};

export class SeatRightMapModalController implements ng.IController {

    public listRows;
    public initCont = 10;
    public addCont = 5;

    constructor () {

    }
    /**
         * Increment files to show
         */
    loadMore = (): void => {
        this.initCont += this.addCont;
        this.removeHidden();
    };

    removeHidden = (): void => {
        this.listRows = angular.element('[data-index="cabins-2"]').find('[data-row]');
        this.listRows.each((index:any, element:any) => {
            if (index <= this.initCont) {
                // angular.element(element).removeAttr("hidden")
                angular.element(element).fadeIn(600);
            }
        });
    };

}




try {
    SeatRightMapModalController.$inject = controllerInfo.inject;
    angular.module(controllerInfo.module).controller(SeatRightMapModalController.name, SeatRightMapModalController);

} catch (error) {
    const mod = angular.module(controllerInfo.module, controllerInfo.required);
    SeatRightMapModalController.$inject = controllerInfo.inject;
    mod.controller(SeatRightMapModalController.name, SeatRightMapModalController);
}